
import {
    EDIT_RENEWAL_SUCCESS,
    EDIT_RENEWAL,
    CHANGE_PAGE,
    GET_ALL_RENEWALS,
    GET_RENEWAL_SUCCESS,
    GET_ALL_RENEWALS_FILTER,
    GET_ALL_RENEWALS_FILTER_SUCCESS,
    SET_RENEWAL_FILTERS,
    SET_VIEW,
    GET_RENEWAL,
} from "../actions/Renewals.action";

const initialState = {
    renewals: [],
    getRenewalsLoading: false,
    getRenewalLoading: false,
    getRenewalsFilterLoading: false,
    editRenewalLoading: false,
    page: 1,
    currentRenewal: {},
    view: true,
};

const RESET_LOADING = "RESET_LOADING"
function branch(state = initialState, action) {
    switch (action.type) {
        case RESET_LOADING:
            return Object.assign({}, state, {
                getRenewalsLoading: false,
                getRenewalLoading: false,
                getRenewalsFilterLoading: false,
                editRenewalLoading: false,
            })
        case SET_VIEW:
            return Object.assign({}, state, {
                view: action.payload.view,
            });
        case SET_RENEWAL_FILTERS:
            return Object.assign({}, state, {
                filters: action.payload.filters,
            });
        case EDIT_RENEWAL_SUCCESS:
            return Object.assign({}, state, {
                currentRenewal: action.payload.editedRenewal
            });
        case EDIT_RENEWAL:
            return Object.assign({}, state, {
                editRenewalLoading: action.payload.editRenewalLoading
            });
        case GET_RENEWAL:
            return Object.assign({}, state, {
                getRenewalLoading: action.payload.getRenewalLoading
            });
        case GET_RENEWAL_SUCCESS:
            return Object.assign({}, state, {
                currentRenewal: action.payload.currentRenewal,
            });

        case GET_ALL_RENEWALS:
            return Object.assign({}, state, {
                getRenewalsLoading: action.payload.getRenewalsLoading,
            });

        case GET_ALL_RENEWALS_FILTER_SUCCESS:
            let oldRenewals = [];

            if (action.payload.page === 1 || !action.payload.view)
                oldRenewals = [];

            else {
                oldRenewals = [...state?.renewals?.newRenewals];
            }
            return Object.assign({}, state, {
                renewals: {
                    newRenewals: action.payload.renewals,
                    oldRenewals: [...oldRenewals],
                    totalRecords: action.payload.totalRecords,
                    totalPages: action.payload.totalPages,
                    page: action.payload.page,
                }
            });
        case GET_ALL_RENEWALS_FILTER:
            return Object.assign({}, state, {
                getRenewalsFilterLoading: action.payload.getRenewalsFilterLoading,
            });

        case CHANGE_PAGE:
            return Object.assign({}, state, {
                page: action.payload.page,
                flag: action.payload.flag
            });

        default:
            return state;
    }

}

export default branch;
